import React from 'react';
import { FileText } from 'lucide-react';

interface OrderInstructionsProps {
  instruction?: string;
}

const OrderInstructions: React.FC<OrderInstructionsProps> = ({ instruction }) => {
  if (!instruction) return null;

  return (
    <div className="mb-8">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <FileText className="w-5 h-5 text-blue-600 mt-0.5" />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-blue-800 mb-1">Order Instructions</h3>
            <p className="text-sm text-blue-700 leading-relaxed">
              {instruction}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderInstructions;
